export { monospacePreStyles as preStyles } from 'app/shared/styles/monospacePre.styles';

export const headerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
};

export const revealButtonStyles = {
  alignSelf: 'flex-start',
};
